import { DTOModel } from "../../models/base/dto-model";
import { DocumentTemplatePlaceholderSTO } from "../../models/document-templates/document-template-placeholder";
import { BaseApiService } from "../base";

export class DocumentTemplatePlaceholderConfigApiService extends BaseApiService<
  DTOModel,
  DocumentTemplatePlaceholderSTO
> {
  constructor() {
    super({
      servicePath: "/WordTemplate",
      loadItemsPath: "/ ",
      saveItemsPath: "/SaveDocumentTemplatePlaceholders",
    });
  }
}
